import { tv } from 'tailwind-variants';

import { fontStyles } from './typography';

/**
 * iOS Safari zooms a focused <input>/<textarea> whose font-size is < 16px.
 * Invariant: keep the MOBILE (base) size at 16px; the tablet+ size is a
 * per-input design choice. Reach for one of these instead of hand-writing
 * text-[..] sizes on an input.
 */
export const iosSafeInputText = {
  sm: 'text-[16px] tablet:text-[13px]', // dense fields (e.g. search)
  md: 'text-[16px] tablet:text-[14px]', // default body input
  base: 'text-[16px]', // 16px on all viewports, no down-scale
} as const;

export const inputStyles = tv({
  slots: {
    root: fontStyles({
      variant: 'BODY_MD',
      class: [
        'h-9',
        'px-3',
        'rounded-sm',
        'bg-token-alphalight-200',
        'shadow-[0_0_0_0px_transparent]',
        'hover:shadow-[0_0_0_1px_var(--color-token-alphalight-500)]',
        'focus-within:shadow-[0_0_0_2px_var(--color-token-purple-900)]',
        'hover:focus-within:shadow-[0_0_0_2px_var(--color-token-purple-900)]',
        'col-span-1',
        'flex',
        'items-center',
        'group',
        'transition-shadow',
        'duration-200',
        'ease-in-out',
        'gap-2',
        iosSafeInputText.md,
      ],
    }),
    input: [
      'placeholder:text-token-gray-700',
      'w-full',
      'disabled:text-token-gray-600',
      'outline-0',
      'focus-within:outline-0',
    ],
    accessoryLeft: ['text-token-gray-1600', 'disabled:text-token-gray-700'],
    accessoryRight: ['text-token-gray-700', 'text-token-gray-600'],
  },
  variants: {
    error: {
      true: {
        root: 'shadow-[0_0_0_2px_var(--color-token-red-900)] hover:shadow-[0_0_0_2px_var(--color-token-red-900)] focus-within:shadow-[0_0_0_2px_var(--color-token-red-900)] hover:focus-within:shadow-[0_0_0_2px_var(--color-token-red-900)]',
        accessoryRight: 'text-token-red-900',
      },
    },
    success: {
      true: {
        root: 'shadow-[0_0_0_2px_var(--color-token-green-900)] hover:shadow-[0_0_0_2px_var(--color-token-green-900)] focus-within:shadow-[0_0_0_2px_var(--color-token-green-900)] hover:focus-within:shadow-[0_0_0_2px_var(--color-token-green-900)]',
        accessoryRight: 'text-token-green-1000',
      },
    },
  },
});
